module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA0BAMAAAAtauZWAAAAIVBMVEX////CvLnGwL3KxMLNycbRzcvZ1dPg3dzw7u308vL39/Zbnf85AAAAAXRSTlMAQObYZgAAAKtJREFUeNpjYMAHOMpxggoGdkGcQJyBXTgUDgJFQpFAEFBSHGEFowSyhayjkoNUEhyfkQyssPiEMKHxCY50CQZGWPwjmEBJUVByqWJgh6UcOLMY1U5UwEpAkqMCjyRuMBglubqIC4RAQXEOUJgGMDTCwpZYyQIgURiAw1gSJcU6OhYwzOgAAscMIJGIIgm0uQDoFjggXhItkApHpKRwKAowVEUuNfGVt/hKagDaGmUZZcyvKAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/floorplan.png
// module id = 2405
// module chunks = 0